/**
 * 遍历ui-core的layout的每一个节点
 * @param layout
 * @param callback
 */
export function layoutEach(layout, callback) {
    const walk = (item) => {
        callback(item);
        if (Array.isArray(item.children)) {
            item.children.forEach(walk);
        }
    };
    walk(layout);
}
